import { FieldDescription, FieldError, fieldIds } from './shared';
import type { FieldProps } from './FieldProps';

export function CheckboxField({ field, value, error, onChange }: FieldProps) {
  const { inputId, descriptionId, errorId } = fieldIds(field.path);
  const describedBy = [field.schema.description ? descriptionId : null, error ? errorId : null]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <label htmlFor={inputId} className="flex items-center gap-2 text-sm font-medium">
        <input
          id={inputId}
          type="checkbox"
          checked={value === true}
          onChange={(event) => onChange(event.target.checked)}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy || undefined}
        />
        {field.schema.title ?? field.key}
        {field.required ? (
          <span aria-hidden="true" className="text-[var(--color-destructive)]">
            *
          </span>
        ) : null}
      </label>
      <FieldDescription id={descriptionId} text={field.schema.description} />
      <FieldError id={errorId} message={error} />
    </div>
  );
}
